// extracted by mini-css-extract-plugin
var _1 = "UserListItemAdditionalInfo-moduleblocked__fe51d";
var _2 = "UserListItemAdditionalInfo-modulechip__BfB4k";
var _3 = "UserListItemAdditionalInfo-moduleemail__wFz1S";
var _4 = "UserListItemAdditionalInfo-modulehover__ypq8P";
export { _1 as "blocked", _2 as "chip", _3 as "email", _4 as "hover" }
